export default "__VITE_ASSET__r001GzAW__"